export default "__VITE_ASSET__f1372cf2__"